module.exports = __webpack_public_path__ + "static/media/materialui.16e05137.svg";